/*
* Copyright (c) 2021 SGS Europe. All rights reserved.
*
* This program is the CONFIDENTIAL and PROPRIETARY property of 2017 SGS Europe.
* Any unauthorised use, reproduction, or transfer of this program is strictly
* prohibited.
*
* File Name: GreenlightEventMessages.js
*
* Description: Contains the code for the Greenlight Message Events.
*
*/

// The event messages object.
var g_oEventMessages = {};

(function () {
	"use strict";

	/*
	 * Event Data is passed in and returned in the following format:
	 * { type: "typeValue", id: "idValue", response: false }
	 * Type - Mandatory String - The event message type.
	 * Id - Optional String - The id to be used by the event.
	 * Success - Response Boolean - Set and returned based on the result.
	 */
	function EventMessages() {

		/**
		 * The supported event message types.
		 */
		this.g_oEventMessageTypes = {
			SaveActiveAnnotations: "saveactiveannot",
			ChangeApprovalView: "changeapprovalview"
		};

		/**
		 * The event domains to be populated on setup.
		 */
		this.g_oEventDomains = [];
	};

	/**
	 * Sets up the event messages for the session.
	 */
	EventMessages.prototype.setupEventMessages = function (szEventDomains) {
		
		// Setup the event domains.
		g_oEventMessages.setupEventMessageDomains(szEventDomains);

		// Ensure we have event domains.
		if (g_oEventMessages.g_oEventDomains.length == 0) {
			return;
		}

		// Add an event lister so that external pages can send post messages to Greenlight to execute particular actions.
		if (window.addEventListener) {
			// For standards-compliant web browsers.
			window.addEventListener("message", function (evt) {
				g_oEventMessages.processEventMessage(evt);
			}, false);
		}
		else {
			// For non-standards-compliant web browsers.
			window.attachEvent("onmessage", function (evt) {
				g_oEventMessages.processEventMessage(evt);
			});
		}
	};

	/**
	 * Sets up the event message domains.
	 * @param {string} szEventDomains - The event domains list.
	 */
	EventMessages.prototype.setupEventMessageDomains = function (szEventDomains) {

		// Split the domains.
		var oSplitDomains = szEventDomains.split(",");

		// Add each of the split domains.
		for (var i = 0; i < oSplitDomains.length; i++) {
			if (oSplitDomains[i].trim().length > 0) {
				g_oEventMessages.g_oEventDomains.push(oSplitDomains[i].trim());
			}
		}
	};

	/**
	 * Displays an event message error.
	 * @param {string} szErrorMessage - The error message.
	 * @param {string} szEventType - The optional event type.
	 */
	EventMessages.prototype.displayEventMessageError = function (szErrorMessage, szEventType) {
		g_oGreenlightMessages.displayErrorBubble(g_oEventMessages.c_szEventMessageError + " " + (szEventType != null ? " (" + szEventType + ") " : "") + szErrorMessage);
	};

	/**
	 * Processes an event message.
	 * @param {object} event - The event to be processed.
	 */
	EventMessages.prototype.processEventMessage = function (event) {
		
		// Ignore messages from internal domains.
		if (event.origin == window.origin) {
			return;
		}

		// Ensure the domain is valid.
		if (!g_oEventMessages.checkEventDomain(event.origin)) {
			g_oEventMessages.displayEventMessageError(g_oEventMessages.c_szEventMessageUnauthorised, null);
			return;
		}

		// Extract the event data.
		var oEventData = g_oEventMessages.getEventData(event.data);

		// Start the event as unsuccessful.
		// This is set to successful during the below actions once performed.
		oEventData["success"] = false;

		// Determine the event to process.
		switch (oEventData.type) {

			// Saving active annotations.
			case g_oEventMessages.g_oEventMessageTypes.SaveActiveAnnotations:
				g_oEventMessages.saveActiveAnnotations(oEventData);
				break;

			// Changing the approval view.
			case g_oEventMessages.g_oEventMessageTypes.ChangeApprovalView:
				g_oEventMessages.changeApprovalView(oEventData);
				break;

			// Unknown message type.
			default:
				g_oEventMessages.displayEventMessageError(g_oEventMessages.c_szEventMessageUnknown, oEventData.type);
				break;
		}

		// Send the return event.
		g_oEventMessages.sendReturnEvent(oEventData);
	};

	/**
	 * Checks the event domain to ensure it is valid.
	 * @param {string} szDomain - The domain to be checked.
	 */
	EventMessages.prototype.checkEventDomain = function (szDomain) {

		// Check the domain against each of the event domains.
		for (var i = 0; i < g_oEventMessages.g_oEventDomains.length; i++) {
			if (szDomain.indexOf(g_oEventMessages.g_oEventDomains[i], szDomain.length - g_oEventMessages.g_oEventDomains[i].length) !== -1) {

				// Return the domain is valid.
				return true;
			}
		}

		// Return the domain is invalid.
		return false;
	};

	/**
	 * Gets the event data.
	 * @param {string} szData - The event data.
	 * @returns {object} - Parsed event data.
	 */
	EventMessages.prototype.getEventData = function (szData) {

		// Outline the event data to be returned.
		var oEventData = {};

		// Add backwards compatibility for the original "saveactiveannot" format.
		if (event.data == "saveactiveannot") {
			return { type: "saveactiveannot" };
		}

		// Parse the event data.
		try {
			oEventData = JSON.parse(szData);
		}
		catch (err) {
			oEventData = {};
		}

		// Return the event data.
		return oEventData;
	};

	/**
	 * Send the return event message.
	 * @param {object} oEventData - The event data.
	 */
	EventMessages.prototype.sendReturnEvent = function (oEventData) {
		window.postMessage(JSON.stringify(oEventData), window.origin);
	};

	/**
	 * Performs the action to save active annotations.
	 */
	EventMessages.prototype.saveActiveAnnotations = function (oEventData) {
		
		// If the attachment window is open, close this.
		if ($("#divUploadOverlay").is(":visible")) {
			$("#divCloseUploadOverlay").click();
		}

		// Simulate the user clicking onto the canvas to trigger the annotation save.
		$("#AnnotationViewer").trigger("pointerdown");

		// Set that the event has been successful.
		oEventData["success"] = true;
	};

	/**
	 * Changes the approval view.
	 * @param {string} oEventData - The event data.
	 */
	EventMessages.prototype.changeApprovalView = function (oEventData) {
		
		// Save any annotations that are open.
		g_oEventMessages.saveActiveAnnotations({});

		// Clear out any new annotations that have now been saved so we do not try to delete these on the document change event.
		for (var i = 0; i < g_oAnnotations.g_oAnnotationsMade.length; i++) {
			if (g_oAnnotations.g_oAnnotationsMade[i].id < 0) {
				$("#" + g_oAnnotations.g_oAnnotationsMade[i].id).remove();
				g_oAnnotations.g_oAnnotationsMade.splice(i, 1);
				i--;
			}
		}

		// Parse the approval id.
		var iApprovalId = parseInt(oEventData.id) || -1;

		// Ensure we have parsed the approval id.
		if (iApprovalId == undefined || iApprovalId == null || iApprovalId < 0) {
			g_oEventMessages.displayEventMessageError(g_oEventMessages.c_szEventMessageInvalidId + " " + iApprovalId.toString(), g_oEventMessages.g_oEventMessageTypes.ChangeApprovalView);
			return;
		}

		// Ensure we are not in a multi view.
		if (typeof (g_oMultiView) == "undefined") {
			g_oEventMessages.displayEventMessageError(g_oEventMessages.c_szEventMessageNotMultiView, g_oEventMessages.g_oEventMessageTypes.ChangeApprovalView);
			return;
		}

		// Get the view index for the matching approval id.
		var iMatchingViewIndex = g_oMultiView.getIndexForApprovalId(iApprovalId);

		// Ensure we have found a matching index.
		if (iMatchingViewIndex == -1) {
			g_oEventMessages.displayEventMessageError(g_oEventMessages.c_szEventMessageNoViewFound + " " + iApprovalId, g_oEventMessages.g_oEventMessageTypes.ChangeApprovalView);
			return;
		}

		// Change the view.
		g_oMultiView.Change(iMatchingViewIndex);

		// Set that the event has been successful.
		oEventData["success"] = true;
	};

	// Add the Text Tools UI object to the window.
	window.EventMessages = EventMessages;
}());